import { render, staticRenderFns } from "./MainFeatures.vue?vue&type=template&id=5331397d&scoped=true&"
import script from "./MainFeatures.vue?vue&type=script&lang=js&"
export * from "./MainFeatures.vue?vue&type=script&lang=js&"
import style0 from "./MainFeatures.vue?vue&type=style&index=0&id=5331397d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331397d",
  null
  
)

export default component.exports